import { Typography } from '@mui/material';

import { useUpdatePiecesMutation } from '@api/piece';
import { PieceAction } from '@apiContract';
import { DialogConfirmation } from '@uiKit/DialogConfirmation';

import { ActionComponentProps } from '../../index';

export const MarkPickedUp = ({ mailpieces, actionStarted, onActionFinish, isForce }: ActionComponentProps) => {
  const [updatePieces, { isLoading }] = useUpdatePiecesMutation();

  const confirmAction = async () => {
    await updatePieces({
      pieces: mailpieces.map((piece) => ({ id: piece.id })),
      action: PieceAction.FinishPickupMailbox,
      isForce,
    }).unwrap();

    onActionFinish();
  };

  const content =
    mailpieces.length === 1 ? (
      'Are you sure you would like to mark this item as picked up?'
    ) : (
      <Typography variant="body1" color="text.secondary">
        Are you sure you would like to mark this <strong>{mailpieces.length}</strong> items as picked up?
      </Typography>
    );

  return (
    <DialogConfirmation
      open={actionStarted}
      loading={isLoading}
      maxWidth="xs"
      title={mailpieces.length === 1 ? 'Mark item as picked up' : 'Mark selected items as picked up'}
      content={content}
      acceptButtonHandleClick={confirmAction}
      cancelButtonHandleClick={onActionFinish}
      acceptButtonTitle="Mark as Picked Up"
      cancelButtonTitle="Cancel"
    />
  );
};
